import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { formatarValor, formatarValorAPI } from '../../common/utils';
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import { FaArrowDown, FaArrowUp, FaCheck, FaTimes, FaStream, FaEye } from "react-icons/fa";

class ProdutosEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            nome: '',
            descricao: '',
            ean: '',
            valor: '',
            erroLoadRegistro: "",
            produto_id: "",
            titulo_pagina: "",
            loading: false,
        };
    }

    componentDidMount(){
        const id = this.props.router.params.id;

        if(id){
            this.setState({
                produto_id: id,
                titulo_pagina: 'Editando Produto',
                loading: true,
                erroLoadRegistro: ''
            })

            //consulta os dados do programa na api
            api.get(`/produtos/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    nome: dados.nome,
                    descricao: dados.descricao,
                    ean: dados.ean,
                    valor: formatarValor(dados.valor),
                    loading: false
                })
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar produto, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        else {
            this.setState({
                produto_id: '',
                titulo_pagina: 'Adicionar Produto',
                loading: false,
                erroLoadRegistro: '',
            })
        }
    }

    carregarCids = async (inputValue) => {
        if (inputValue.length < 3) return [];
        try {
            const response = await api.get(`/doencas/cids/?descricao=${inputValue}`);
            const opcoes = response.data.results.map(cid => ({
                value: cid.id,
                label: cid.codigo + ' - ' + cid.descricao
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar formulários:', error);
            return [];
        }
    };

    enviaRegistro = (e) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            nomeHelper: "",
            descricaoHelper: "",
            eanHelper: "",
            valorHelper: "",
        });

        const valorFormatadoAPI = formatarValorAPI(this.state.valor);

        //vererifica se é edição ou adição
        const url = (this.state.produto_id) ? '/produtos/'+this.state.produto_id+'/' : '/produtos/'
        const metodo = (this.state.produto_id) ? 'put' : 'post'

        formData.append('nome', this.state.nome);
        formData.append('descricao', this.state.descricao);
        formData.append('ean', this.state.ean);
        formData.append('valor', valorFormatadoAPI);

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.produto_id) ? 'Produto atualizado com sucesso' : 'Produto cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.produto_id){
                this.props.router.navigate("/produtos");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o produto, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'nome'){
                        this.setState({ nomeHelper: value })
                    }
                    if(key === 'descricao'){
                        this.setState({ descricaoHelper: value })
                    }
                    if(key === 'valor'){
                        this.setState({ valorHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "valor") {
            const valorFormatado = formatarValor(value);
            this.setState({ [name]: valorFormatado });
        } else {
            this.setState({ [name]: value });
        }
    };

    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosProduto" id="tabs-produto" className="aditus-tabs">
                    <Tab eventKey="dadosProduto" title="Dados do Produto">
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form onSubmit={this.enviaRegistro}>
                                    <h4>Dados do Produto</h4>
                                    <Row>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nome do Produto</Form.Label>
                                                <Form.Control type="text" name="nome" required placeholder="Nome do Produto" value={this.state.nome} onChange={this.handleChange} />    
                                                <Form.Text id="formNomeHelpBlock" className="text-danger">{this.state.nomeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>EAN</Form.Label>
                                                <Form.Control type="text" name="ean" required placeholder="EAN" value={this.state.ean} onChange={this.handleChange} />    
                                                <Form.Text id="formEanHelpBlock" className="text-danger">{this.state.eanHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Valor</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="valor"
                                                    value={this.state.valor} 
                                                    onChange={this.handleChange}
                                                />
                                                <Form.Text id="formEanHelpBlock" className="text-danger">{this.state.eanHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} className="d-none">
                                            <Form.Group className="mb-3">
                                                <Form.Label>CID</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={this.carregarCids}
                                                    defaultOptions
                                                    name="cid"
                                                    placeholder="Buscar CID..."
                                                    noOptionsMessage={() => "Nenhum CID encontrado"}
                                                    onChange={e => this.handleChange(index, e, 'cid')}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Descrição do Produto</Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    required 
                                                    placeholder="Descrição" 
                                                    name="descricao"
                                                    value={this.state.descricao} 
                                                    onChange={this.handleChange} 
                                                    className="custom-textarea"
                                                />
                                                <Form.Text id="formDescricaoHelpBlock" className="text-danger">
                                                    {this.state.descricaoHelper}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {this.state.erroLoadRegistro ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadRegistro}
                                    </Alert> : ''
                                    }                                      
                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar
                                            </>
                                        )}
                                    </Button>
                                </Form> 
                            </Card.Body>                
                        </Card>
                    </Tab>
                    {this.state.formulario_id && (
                        <Tab eventKey="camposFormulario" title="Campos do Formulário">
                            <Card className="cardDestaque">
                                <Card.Body>                    
                                    <Form onSubmit="">
                                        <h4>Campos do Formuário</h4>
                                    </Form> 
                                </Card.Body>                
                            </Card>
                        </Tab>
                    )}
                </Tabs>
            </div>
        )
    }
}

export default withRouter(ProdutosEdit);